module.exports = __webpack_public_path__ + "static/media/exc_fir_gro.13b621ee.png";